import { styled, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

// https://www.figma.com/file/oy0lqfg1RnOZ1Y7129AJmc/KAIZEN-Design-Library?node-id=40%3A11173
const LabelExtraSmall = styled(Typography)({
  color: COLOR_TEXT_MAIN,
  fontWeight: 700,
  fontSize: '12px',
  fontStyle: 'normal',
  lineHeight: '100%',
  textAlign: 'left',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
});

export const LabelExtraSmallStyle = {
  color: COLOR_TEXT_MAIN,
  fontWeight: 700,
  fontSize: '12px',
  fontStyle: 'normal',
  lineHeight: '100%',
  // textAlign: 'left',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
};

export default LabelExtraSmall;
